import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as display from '../../../../../display'

@ngCore.Component({
  imports: [
    ds.overlay.slideout.Component,
    display.variableList.Component,
    ds.button.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
  ],
  selector: 'atn-mosaic-variables-slideout',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.variableOverrides.Feature} */
  public readonly variablesFeature = ngCore.inject(
    state.variableOverrides.Feature,
  )

  /** @see {@link state.mosaic.endUser.currentRendering.Feature } */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )

  /**
   * Returns true if the current page has variable definitions.
   */
  public hasPageVariablesSg = ngCore.computed(() => {
    const pageId = this.currentRendering.selectors.context.asSignal()?.pageId
    return pageId
      ? this.variablesFeature.selectors
          .hasDefinitions({ page: { pageId } })
          .asSignal()
      : false
  })

  /**
   * Returns true if the current app/session has variable definitions.
   */
  public hasSessionVariablesSg = ngCore.computed(() => {
    const appId = this.currentRendering.selectors.context.asSignal()?.appId

    return appId
      ? this.variablesFeature.selectors
          .hasDefinitions({ session: { appId } })
          .asSignal()
      : false
  })

  /**
   * Show variables slideout only if focused variables holder is widget or page.
   *
   * __NOTE__: Other variable holder types use different components to manage
   * variables
   */
  public readonly showSlideoutSg = ngCore.computed(
    (
      isWidgetFocused = this.variablesFeature.selectors.isWidgetFocused.asSignal(),
      isPageFocused = this.variablesFeature.selectors.isPageFocused.asSignal(),
      isSessionFocused = this.variablesFeature.selectors.isSessionFocused.asSignal(),
    ) => isWidgetFocused || isPageFocused || isSessionFocused,
  )

  /**
   * Apply edited variable values
   */
  public applyClickHandler(): void {
    const holder = this.variablesFeature.selectors.focused.asSignal()
    if (holder) {
      this.variablesFeature.actions.applyValuesFor
        .from('VariablesSlideout.Apply.Button.Clicked')
        .dispatch({
          holder,
        })
    }
  }

  /** Close the slideout */
  public cancelClickHandler(): void {
    this.variablesFeature.actions.removeFocused
      .from('VariablesSlideout.Cancel.Button.Clicked')
      .dispatch()
  }

  /** Handles tab change events inside the Variables slideout. */
  public handleTabChange(tab: ds.tabs.models.Tab | undefined): void {
    if (!tab) {
      return
    }
    const context = this.currentRendering.selectors.context.asSignal()
    if (!context) {
      return
    }

    const { appId, pageId, scenarioId } = context

    this.variablesFeature.actions.setFocused
      .from('VariablesSlideout.Tab.Clicked')
      .dispatch(
        tab.name === 'Page'
          ? { page: { appId, pageId, scenarioId } }
          : { session: { appId } },
      )
  }

  /**
   * Reset variable values in state
   */
  public resetClickHandler(): void {
    const holder = this.variablesFeature.selectors.focused.asSignal()
    if (holder) {
      this.variablesFeature.actions.reset
        .from('VariablesSlideout.Reset.Button.Clicked')
        .dispatch({
          holder,
        })
    }
  }
}
